import axios from 'axios'
import cookie from 'vue-cookie'
import store from '@/store'
import eventBus from '../main'
import moment from 'moment'
import momentTz from 'moment-timezone'

let timezone = localStorage.getItem('x-timezone')
timezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone

const api = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    common: {
      'x-yg-token': cookie.get(process.env.VUE_APP_PORTAL_YG_TOKEN) || '',
      'x-timezone': timezone
    }
  }
})

const $_utcToLocal = (date, fromFormat, toFormat) => { // eslint-disable-line camelcase
  if (!date) return null

  let timezone = localStorage.getItem('x-timezone')
  timezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  return (date) ? momentTz.utc(date, (fromFormat || 'YYYY-MM-DDTHH:mm:ss')).tz(timezone).format((toFormat || 'YYYY-MM-DDTHH:mm:ss')) : null
}

const $_recursiveUpdate = (obj, options) => { // eslint-disable-line camelcase
  if (obj && (typeof obj === 'object' && !(obj instanceof FormData))) {
    if (Array.isArray(obj) && obj.length) {
      for (const arrayItemIndex in obj) {
        obj[arrayItemIndex] = $_recursiveUpdate(obj[arrayItemIndex], options)
      }
      return obj
    } else if ((typeof obj === 'object') && Object.keys(obj).length) {
      const newobj = {}
      for (const key in obj) {
        if (obj[key] && (typeof obj[key] === 'object')) newobj[key] = $_recursiveUpdate(obj[key], options)
        else {
          if ((obj[key] && (typeof (obj[key]) === 'string'))) {
            if (options.utcToLocal) {
              if (moment(obj[key], 'DD.MM.YYYYTHH.mm.ss', true).isValid()) newobj[key] = $_utcToLocal(obj[key]) // common datetime
              else if (moment(obj[key].replace(/\.\d+Z$/, ''), 'YYYY-MM-DDTHH:mm:ss', true).isValid()) newobj[key] = $_utcToLocal(obj[key], 'YYYY-MM-DDTHH:mm:ss') // datetime with offset value
              else newobj[key] = obj[key]
            } else if (options.dateToDateTime) newobj[key] = (moment(obj[key], 'DD.MM.YYYY', true).isValid()) ? moment(obj[key], 'DD.MM.YYYY').format('YYYY-MM-DDT23:59:59') : obj[key]
            else newobj[key] = obj[key].trim()
          } else newobj[key] = obj[key]
        }
      }
      return newobj
    } else return obj
  } else return obj
}


api.interceptors.response.use((res) => {
  if (res.status.toString().charAt(0) === '2' && res.data) res.data = $_recursiveUpdate(res.data, { utcToLocal: true })
  return res
}, ({ response = {} } = {}) => {
  if (!response) return {}

  let { status, data, statusText } = response
  if (status >= 400) {
    switch (status) {
      case 401:
        store.dispatch('logout')
        break
      default:
        eventBus.$emit('snackbar', { text: ((data.err) ? data.err.message : (data || statusText)), color: 'error' })
        break
    }
  }
})


export { api }